
import {FC} from 'external/react'
import Icon from 'external/fortawesome'
import Avatar from 'components/Avatar'
import { User } from 'types/context/parent'

import LabeledIcon from 'components/LabeledIcon'

export type UserCardContentProps = {
    user: User
    onEditUserClick?: (user: User) => void
}

const UserCardContent: FC<UserCardContentProps> = props => {
    const {user, onEditUserClick} = props
    return (
        <div className='d-flex text-black' style={{ padding: '0px 10px' }}>
            <div className='flex-shrink-0'>
                <Avatar name={user.first_name} lastname={user.last_name} size={'lg'} />
            </div>
            <div className='flex-grow-1 ms-3' style={{ textAlign: 'left', display: 'grid' }} >
                <LabeledIcon  label={user.name} icon='faUser'  />
                <LabeledIcon label={user.phone} icon='faPhone' hiddenIfEmpty={true} />
                <LabeledIcon label={user.email} icon='faEnvelope' textOverflow='ellipsis' />
                <LabeledIcon label={`Paquetes: ${user.packages}`} icon='faBox' hiddenIfEmpty={true} />
            </div>
            <div className='flex-shrink-0 d-flex'>
                <span className='span--edit' title='editar' onClick={() => onEditUserClick && onEditUserClick(user)}>
                    <Icon name='faPenToSquare' />
                </span>
            </div>
 
        </div>
    )
}
    
export {UserCardContent as default}
